/**
 * Forces the given node and every scrollable ancestor (parent, grandparent, ...) to the top.
 *
 * The widget renders inside a shadow DOM, so the traversal crosses the shadow boundary via the
 * host element. Resetting the whole ancestor chain guarantees a full scroll-to-top regardless of
 * which container actually scrolls on a given viewport (e.g. the inner container on desktop vs the
 * outer `main-content`/body on mobile).
 */
export const forceAncestorsToTop = (start: Node | null): void => {
    let node: Node | null = start;

    while (node) {
        if (node instanceof HTMLElement) node.scrollTop = 0;

        const root = node.getRootNode();
        node = node.parentElement ?? (root instanceof ShadowRoot ? root.host : null);
    }
};
